"use strict";

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.only = exports.between = exports.down = exports.up = exports._makeStyledBreakpoints = exports._makeErrorMessage = exports._withMinAndMaxMedia = exports._get = exports._type = void 0;

exports._type = function (x) {
  return Object.prototype.toString.call(x).slice(8, -1);
};

exports._get = function (path, obj, defaultValue) {
  var head = path[0];
  var tail = path.slice(1);

  if (!tail.length) {
    var res = obj[head];
    var isEmpty = exports._type(res) === 'Object' && Object.keys(res).length === 0 || exports._type(res) === 'Null' || exports._type(res) === 'Undefined';
    return isEmpty ? defaultValue : obj[head];
  }

  return exports._get(tail, obj[head], defaultValue);
};

exports._withMinAndMaxMedia = function (x, y) {
  return "@media (min-width: " + x + ") and (max-width: " + y + ")";
};

exports._makeErrorMessage = function (breakName, breaks) {
  return "'" + breakName + "' is invalid breakpoint name. Use '" + Object.keys(breaks).join(', ') + "'.";
};

exports._makeStyledBreakpoints = function (options) {
  var _options = options || {};

  var state = {
    pathToMediaQueries: _options.pathToMediaQueries || ['breakpoints'],
    errorPrefix: _options.errorPrefix || '[styled-breakpoints]: ',
    defaultMediaQueries: _options.defaultMediaQueries || {
      tablet: '768px',
      desktop: '992px',
      lgDesktop: '1200px'
    },
    browserContext: 16,
    throwError: function throwError(message) {
      throw Error(state.errorPrefix + message);
    },
    throwInvalidBreakValue: function throwInvalidBreakValue(breaks) {
      Object.keys(breaks).forEach(function (x) {
        if (x.indexOf('px') === -1) {
          state.throwError("Check your theme. '" + breaks[x] + "' is invalid breakpoint. Use pixels.");
        }
      });
    },
    throwIsInvalidBreakName: function throwIsInvalidBreakName(breakName, breaks) {
      if (!breaks[breakName]) {
        state.throwError(exports._makeErrorMessage(breakName, breaks));
      }
    },
    throwIsLastBreak: function throwIsLastBreak(breakName, breaks) {
      var names = Object.keys(breaks);
      var penultimateBreakName = names[names.length - 2];
      var isInvalid = names.indexOf(breakName) === names.length - 1;

      if (isInvalid) {
        state.throwError("Don't use '" + breakName + "' because it doesn't have a maximum width. Use '" + penultimateBreakName + "'. See https://github.com/mg901/styled-breakpoints/issues/4 .");
      }
    },
    throwIsInvalidNextBreakValue: function throwIsInvalidNextBreakValue(name, breaks) {
      if (!breaks[name]) {
        state.throwError("'" + name + "' is invalid breakpoint name. Use '" + Object.keys(breaks).slice(0, -1).join(', ') + "'.");
      }
    },
    throwIsInvalidOrientation: function throwIsInvalidOrientation(x) {
      if (x !== 'portrait' && x !== 'landscape') {
        state.throwError("'" + x + "' is invalid orientation. Use 'landscape' or 'portrait'.");
      }
    },
    withOrientationOrNot: function withOrientationOrNot(x, y) {
      if (y) {
        state.throwIsInvalidOrientation(y);
        return x + " and (orientation: " + y + ")";
      }

      return x;
    },
    toEm: function toEm(x) {
      return parseFloat(x) / state.browserContext + "em";
    },
    getBreakpointsFromTheme: function getBreakpointsFromTheme(theme) {
      return exports._get(state.pathToMediaQueries, theme, state.defaultMediaQueries);
    },
    getNextBreakpointName: function getNextBreakpointName(name) {
      return function (breaks) {
        state.throwIsInvalidBreakName(name, breaks);
        state.throwIsLastBreak(name, breaks);
        var names = Object.keys(breaks);
        return names[names.indexOf(name) + 1];
      };
    },
    getNextBreakpointValue: function getNextBreakpointValue(name, breaks) {
      state.throwIsInvalidNextBreakValue(name, breaks);
      var getNextName = state.getNextBreakpointName(name);
      return parseFloat(breaks[getNextName(breaks)]) - 0.02 + "px";
    },
    getBreakpointValue: function getBreakpointValue(name, breaks) {
      state.throwIsInvalidBreakName(name, breaks);
      return breaks[name];
    },
    calcMinWidth: function calcMinWidth(name, theme) {
      return state.toEm(state.getBreakpointValue(name, state.getBreakpointsFromTheme(theme)));
    },
    calcMaxWidth: function calcMaxWidth(name, theme) {
      return state.toEm(state.getNextBreakpointValue(name, state.getBreakpointsFromTheme(theme)));
    },
    up: function up(name, orientation) {
      return function (props) {
        return state.withOrientationOrNot("@media (min-width: " + state.calcMinWidth(name, props.theme) + ")", orientation);
      };
    },
    down: function down(name, orientation) {
      return function (props) {
        return state.withOrientationOrNot("@media (max-width: " + state.calcMaxWidth(name, props.theme) + ")", orientation);
      };
    },
    between: function between(min, max, orientation) {
      return function (props) {
        return state.withOrientationOrNot(exports._withMinAndMaxMedia(state.calcMinWidth(min, props.theme), state.calcMaxWidth(max, props.theme)), orientation);
      };
    },
    only: function only(name, orientation) {
      return function (props) {
        return state.withOrientationOrNot(exports._withMinAndMaxMedia(state.calcMinWidth(name, props.theme), state.calcMaxWidth(name, props.theme)), orientation);
      };
    }
  };
  return state;
};

exports.up = (_a = exports._makeStyledBreakpoints(), _a.up), exports.down = _a.down, exports.between = _a.between, exports.only = _a.only;